import { useState, useCallback } from "react";

export interface UseCustomerSelectionReturn {
  selectedCustomerIds: string[];
  handleSelectionChange: (customerIds: string[]) => void;
  handleRemoveCustomer: (customerId: string) => void;
  clearSelection: () => void;
  selectedCount: number;
}

/**
 * Custom hook for managing customer selection state
 * Provides consistent customer selection logic across components
 */
export function useCustomerSelection(
  initialSelection: string[] = [],
): UseCustomerSelectionReturn {
  const [selectedCustomerIds, setSelectedCustomerIds] =
    useState<string[]>(initialSelection);

  const handleSelectionChange = useCallback((customerIds: string[]) => {
    setSelectedCustomerIds(customerIds);
  }, []);

  const handleRemoveCustomer = useCallback((customerId: string) => {
    setSelectedCustomerIds((prev) => prev.filter((id) => id !== customerId));
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedCustomerIds([]);
  }, []);

  return {
    selectedCustomerIds,
    handleSelectionChange,
    handleRemoveCustomer,
    clearSelection,
    selectedCount: selectedCustomerIds.length,
  };
}
